import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateVideoEpisodeFailAction,
  CreateVideoEpisodeSuccessAction,
  DeleteVideoEpisodeFailAction,
  DeleteVideoEpisodeSuccessAction,
  FetchVideoEpisodesFailureAction,
  FetchVideoEpisodesRequestAction,
  FetchVideoEpisodesSuccessAction,
  stateStatusType,
  UpdateVideoEpisodeFailAction,
  UpdateVideoEpisodeSuccessAction,
  VideoEpisodeActions,
} from "./actionType";
import { initialState, VideoEpisodeState } from "./state";

//FetchVideoEpisodeRequest
const FetchVideoEpisodesRequest = (
  state: VideoEpisodeState,
  action: FetchVideoEpisodesRequestAction
) => {
  return updateObject(state, {
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchVideoEpisodesSuccess = (
  state: VideoEpisodeState,
  action: FetchVideoEpisodesSuccessAction
) => {
  return updateObject(state, {
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_episode: action.payload,
    },
  });
};

const FetchVideoEpisodesFail = (
  state: VideoEpisodeState,
  action: FetchVideoEpisodesFailureAction
) => {
  return updateObject(state, {
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      video_episode: null,
    },
  });
};

//create series
const CreateVideoSeriesSuccess = (
  state: VideoEpisodeState,
  action: CreateVideoEpisodeSuccessAction
) => {
  const newVideoSeries = state.videoEpisodeState.video_episode ?? [];
  return updateObject(state, {
    genericVideoEpisodeState: {
      ...state.genericVideoEpisodeState,
      isLoading: false,
      error: null,
    },
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      video_episode: [...newVideoSeries, action.payload],
    },
  });
};
const CreateVideoSeriesFail = (
  state: VideoEpisodeState,
  action: CreateVideoEpisodeFailAction
) => {
  return updateObject(state, {
    genericVideoEpisodeState: {
      ...state.genericVideoEpisodeState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: null,
    },
  });
};

//update series
const UpdateVideoSeriesSuccess = (
  state: VideoEpisodeState,
  action: UpdateVideoEpisodeSuccessAction
) => {
  const newVideoSeries =
    state.videoEpisodeState?.video_episode.map((items) =>
      items.id === action.payload.id ? action.payload : items
    ) ?? [];
  return updateObject(state, {
    genericVideoEpisodeState: {
      ...state.genericVideoEpisodeState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_episode: [...newVideoSeries],
    },
  });
};
const UpdateVideoSeriesFail = (
  state: VideoEpisodeState,
  action: UpdateVideoEpisodeFailAction
) => {
  return updateObject(state, {
    genericVideoEpisodeState: {
      ...state.genericVideoEpisodeState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      error:null,
      status: stateStatusType.FAILED,
    },
  });
};

//create series
const DeleteVideoSeriesSuccess = (
  state: VideoEpisodeState,
  action: DeleteVideoEpisodeSuccessAction
) => {
  const newVideoSeries = state.videoEpisodeState?.video_episode.filter(
    (items) => items.id !== action.payload
  );
  return updateObject(state, {
    genericVideoEpisodeState: {
      ...state.genericVideoEpisodeState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_episode: [...newVideoSeries],
    },
  });
};
const DeleteVideoSeriesFail = (
  state: VideoEpisodeState,
  action: DeleteVideoEpisodeFailAction
) => {
  return updateObject(state, {
    genericVideoEpisodeState: {
      ...state.genericVideoEpisodeState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoEpisodeState: {
      ...state.videoEpisodeState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const VideoEpisodeReducer = (
  state = initialState,
  action: VideoEpisodeActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_VIDEO_EPISODES_REQUEST:
      return FetchVideoEpisodesRequest(state, action);
    case actionTypes.FETCH_VIDEO_EPISODES_SUCCESS:
      return FetchVideoEpisodesSuccess(state, action);
    case actionTypes.FETCH_VIDEO_EPISODES_FAIL:
      return FetchVideoEpisodesFail(state, action);
    case actionTypes.CREATE_VIDEO_EPISODE_SUCCESS:
      return CreateVideoSeriesSuccess(state, action);
    case actionTypes.CREATE_VIDEO_EPISODE_FAIL:
      return CreateVideoSeriesFail(state, action);
    case actionTypes.UPDATE_VIDEO_EPISODE_SUCCESS:
      return UpdateVideoSeriesSuccess(state, action);
    case actionTypes.UPDATE_VIDEO_EPISODE_FAIL:
      return UpdateVideoSeriesFail(state, action);
    case actionTypes.DELETE_VIDEO_EPISODE_SUCCESS:
      return DeleteVideoSeriesSuccess(state, action);
    case actionTypes.DELETE_VIDEO_EPISODE_FAIL:
      return DeleteVideoSeriesFail(state, action);
    default:
      return state;
  }
};

export default VideoEpisodeReducer;
